CollectionWithHelpers = require 'models/collections/internal/collection-with-helpers'
CustomEmoji = require 'models/custom-emoji'

module.exports = class CustomEmojiList extends CollectionWithHelpers
  model: CustomEmoji
  url: -> "/1/member/#{ @member.id }/customEmoji"

  initialize: (list, { @member }) ->



// WEBPACK FOOTER //
// ./app/scripts/models/collections/custom-emoji-list.coffee